import { BrowserRouter, Route, Routes } from 'react-router-dom';
import FallbackPage from '../pages/FallbackPage';
import HomePage from '../pages/HomePage';
import AdminAuthGuard from '../guards/AdminAuthGuard';
import AdminPage from '../pages/AdminPage';
import PresentationPage from '../pages/PresentationPage';
import TenantContextProvider from '../contexts/TenantContext';

/**
 * AppRouter component
 *
 * @return {*}  {JSX.Element}
 */
const AppRouter = (): JSX.Element => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <AdminAuthGuard fallback={<HomePage />}>
              <TenantContextProvider>
                <AdminPage />
              </TenantContextProvider>
            </AdminAuthGuard>
          }
        />
        <Route
          path="/presentation"
          element={
            <AdminAuthGuard fallback={<HomePage />}>
              <TenantContextProvider>
                <PresentationPage />
              </TenantContextProvider>
            </AdminAuthGuard>
          }
        />
        <Route path="*" element={<FallbackPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
